<template>
  <b-modal
    id="studentExaminationRoomAdd"
    ref="studentExaminationRoomAdd"
    body-class="position-static"
    centered
    size="lg"
    title="Thêm sinh viên thi bổ sung"
    :no-close-on-backdrop="true"
    @hide="onHide"
    @show="onShow"
  >
    <vue-good-table
      line-numbers
      :columns="columns"
      :rows="studentReExams"
      :pagination-options="paginationOptions"
      :select-options="selectOptions"
      @on-selected-rows-change="selectionChanged($event)"
    >
      <div
        slot="emptystate"
        style="text-align: center; font-weight: bold"
      >
        Không có bản ghi nào !
      </div>
      <template
        slot="table-row"
        slot-scope="props"
      >
        <span>{{ props.formattedRow[props.column.field] }}</span>
      </template>
    </vue-good-table>
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-end">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          :disabled="selectedRows.length === 0"
          variant="primary"
          class="mr-1"
          @click="onSave('hide')"
        >
          <span class="text-right">
            <feather-icon icon="CheckIcon" /> Thêm vào danh sách
          </span>
        </b-button>

        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="outline-secondary"
          @click="$bvModal.hide('studentExaminationRoomAdd')"
        >
          <span class="text-right">
            <feather-icon icon="XIcon" /> Hủy
          </span>
        </b-button>
      </div>
    </template>
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      no-wrap
      :show="isLoading"
    />
  </b-modal>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import {
  BButton,
  BModal, BOverlay,
  VBTooltip,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { required } from '@core/utils/validations/validations'
import { VueGoodTable } from 'vue-good-table'

export default {
  name: 'StudentExaminationRoomAdd',
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  components: {
    BModal,
    BOverlay,
    BButton,
    VueGoodTable,
  },
  props: {
    examinationRoomId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
      columns: [
        {
          label: 'Mã sinh viên',
          field: 'code',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Họ và tên',
          field: 'name',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
      selectOptions: {
        enabled: true,
        selectOnCheckboxOnly: true,
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true,
        selectAllByGroup: true,
      },
      paginationOptions: {
        enabled: false,
      },
      selectedRows: [],
      required,
    }
  },
  computed: {
    ...mapGetters({
      studentReExams: 'studentExaminationRoom/studentReExams',
    }),
  },
  methods: {
    ...mapActions({
      getStudentReExam: 'studentExaminationRoom/getStudentReExam',
      insertStudentReExamExaminationRoom: 'studentExaminationRoom/insertStudentReExamExaminationRoom',
    }),
    selectionChanged(event) {
      this.selectedRows = event.selectedRows
    },
    async onShow() {
      this.isLoading = true
      try {
        await this.getStudentReExam({ examinationRoomId: this.examinationRoomId })
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    onHide() {
      this.selectedRows = []
    },
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
    async onSave(type = null) {
      if (this.selectedRows.length === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Vui lòng chọn sinh viên!',
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
        return
      }
      const studentsSelected = this.selectedRows?.map(item => item.id).join(',') || ''
      this.isLoading = true
      try {
        const response = await this.insertStudentReExamExaminationRoom({
          studentCreditClassIds: studentsSelected,
          examinationRoomId: this.examinationRoomId,
        })
        if (response) {
          const { isSuccessful, message } = response
          if (isSuccessful) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: message,
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            if (type === 'hide') {
              this.$bvModal.hide('studentExaminationRoomAdd')
            }
            this.$emit('succeed')
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: message,
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
          }
        }
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },

  },
}
</script>
<style scoped lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
